import $ from 'jquery';
import Menu from './Menu';
import Header from './Header';
import Toolbar from './Toolbar';
import Columns from './Columns';
import SmartFooter from './SmartFooter';
import FixNavigation from './FixNavigation';
import TermNavigation from './TermNavigation';
import ImportMemberClicks from './ImportMemberClicks';

// Set the proper doctype
const newDocType = document.implementation.createDocumentType('html', '', '');
document.doctype.parentNode.replaceChild(newDocType, document.doctype);

// Add the theme styling.
const styles = document.createElement('link');
styles.type = 'text/css';
styles.rel = 'stylesheet';
styles.href = 'https://www.capio.org/sites/default/themes/dtheme/third-party/memberclicks.min.css';
document.head.appendChild(styles);

// Manage application after the remote import from the main site.
const onImportComplete = () => {
  // Add the instant class initially.
  document.body.classList.add('instant');

  // Fix our damn menus from displaying orphaned children
  $('.primary-navigation').each((i, element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // Main/Primary Site Navigation
  $('#block-nice_menus-3').each((i, element) => {
    if (!element.Menu) {
      // element.Menu = new Menu(element);
      element.Menu = new Menu(element);
    }
  });

  // Controls the states of the menu and search states
  $('.toolbar').each((i, element) => {
    if (!element.Toolbar) {
      element.Toolbar = new Toolbar(element);
    }
  });

  // Controls the page overlay display
  $('.overlay').bind('click', () => {
    document.body.removeClass('menu-active search-active');
  });

  // Fixed Header using Headroom.js
  $('.headroom').each((i, element) => {
    if (!element.Header) {
      element.Header = new Header(element);
      $(element).addClass('ready');
    }
  });

  // Smart Footer
  $('.page-footer').each((i, element) => {
    const $footprint = $('.footprint');
    if (!element.SmartFooter && $footprint.length) {
      setTimeout(() => {
        element.SmartFooter = new SmartFooter(element, $footprint);
      }, 500);
    }
  });

  // Columns
  $('.footerlinks').each((i, element) => {
    if (!element.columns) {
      element.columns = new Columns(element, {
        columns: 2,
        item: '.views-row',
        parent: '.view-content',
        blockName: 'footerlinks',
      });
    }
  });

  // Term Navigation
  $('.term-nav').each((i, element) => {
    if (!element.TermNavigation) {
      element.TermNavigation = new TermNavigation(element);
    }
  });

  // Add the delayed classname 500ms later.
  setTimeout(() => {
    document.body.classList.add('delayed');
  }, 500);
};

// Import page markup from main site.
const Import = new ImportMemberClicks(document.body);
Import.callback = onImportComplete;
